import React from 'react';
import {
  ButtonGroupProps as ChakraButtonGroupProps,
  ButtonGroup as ChakraButtonGroup,
  forwardRef,
} from '@chakra-ui/react';
import { ButtonVariants, ButtonColorScheme, ButtonSizes } from './button';
import { ColorMode } from '@allergan-data-labs/alle-elements-core';
import { ButtonGroupContext } from './button-context';

export interface ButtonGroupProps extends ChakraButtonGroupProps {
  /** The visual style of the Button */
  variant?: ButtonVariants;
  /** The size of the Button */
  size?: ButtonSizes;
  /** The visual color appearance of the Button */
  colorScheme?: ButtonColorScheme;
  /** The color mode applied to buttons */
  colorMode?: ColorMode;
  children?: React.ReactNode;
  /** The way the buttons will be positioned. If set to vertical, the buttons will be stacked on top of each other. By default, the orientation is set to horizontal */
  orientation?: 'vertical' | 'horizontal';
}

export const ButtonGroup = forwardRef<ButtonGroupProps, 'div'>(
  ({ children, ...props }, ref) => {
    let spacing = '12';

    if (props.size === 'sm' || props.size === 'xs') {
      spacing = '8';
    }

    if (props.size === 'lg') {
      spacing = '16';
    }
    return (
      <ButtonGroupContext.Provider value={props}>
        <ChakraButtonGroup ref={ref} spacing={spacing} {...props}>
          {children}
        </ChakraButtonGroup>
      </ButtonGroupContext.Provider>
    );
  }
);
